$(document).ready(function() {
    // Mobile navigation
    $('.sp-mobile-button').on('click', function() {
        $('.sp-mobile-nav').slideToggle(500);
    });
});